var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.value.number,
      "breadCrumbs": _vm.breadCrumbs,
      "chips": _vm.chips,
      "actions": _vm.actions
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      },
      "alertClicked": function alertClicked($event) {
        return $event.exec();
      }
    }
  }), _c('v-divider', {
    staticClass: "mt-2 mb-n4"
  }), _c('m-detail-view-grid', {
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_vm.sharedContent.length ? _c('div', [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.shared")) + " ")]), _vm._l(_vm.sharedContent, function (shared) {
          return _c('v-card', {
            key: shared.id + 'shared',
            staticClass: "mb-1",
            attrs: {
              "outlined": ""
            }
          }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
            staticClass: "ml-5 mr-n4"
          }, [_vm._v(" mdi-share ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            attrs: {
              "color": shared.expirationColor
            },
            on: {
              "click": function click($event) {
                _vm.selectedSharedContent = shared;
              }
            }
          }, [_vm._v(" " + _vm._s(shared.expirationReadable) + " ")])]), shared.refs.length ? _c('v-list-item-subtitle', _vm._l(shared.refs, function (refs) {
            return _c('span', {
              key: refs.refId + refs.refType,
              staticClass: "mr-1",
              attrs: {
                "x-small": ""
              }
            }, [_c('v-icon', {
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(refs.refType).icon) + " ")])], 1);
          }), 0) : _vm._e()], 1)], 1)], 1);
        })], 2) : _vm._e(), _vm.value.seller && _vm.value.seller.ref ? _c('div', [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimateRequest.seller")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-invoice-party', {
          attrs: {
            "item": _vm.value.seller,
            "partnerId": _vm.value.partnerId
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.openBuyerSellerSideCard(_vm.value.seller.ref);
            }
          },
          scopedSlots: _vm._u([_vm.value.seller.ref && _vm.value.seller.ref.refType ? {
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.value.seller.ref.refType).icon) + " ")])];
            },
            proxy: true
          } : null], null, true)
        })], 1)], 1) : _vm._e(), _vm.value.buyer && _vm.value.buyer.ref ? _c('div', [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimateRequest.buyer")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-invoice-party', {
          attrs: {
            "item": _vm.value.buyer,
            "partnerId": _vm.value.partnerId
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.openBuyerSellerSideCard(_vm.value.buyer.ref);
            }
          },
          scopedSlots: _vm._u([_vm.value.buyer.ref && _vm.value.buyer.ref.refType ? {
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.value.buyer.ref.refType).icon) + " ")])];
            },
            proxy: true
          } : null], null, true)
        })], 1)], 1) : _vm._e(), _c('v-subheader', {
          staticClass: "mt-2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.refs")) + " ")]), _c('refs-select', {
          ref: "refsSelect",
          attrs: {
            "partnerId": _vm.value.partnerId,
            "loading": _vm.isLoadingRefs,
            "suggested": [],
            "listMode": false,
            "hideEditButton": false,
            "categories": _vm.refsCategories,
            "hideSuggestions": true,
            "confirmable": false
          },
          on: {
            "confirm": _vm.saveRefs,
            "change": _vm.saveRefs,
            "input": _vm.saveRefs
          },
          model: {
            value: _vm.value.refs,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "refs", $$v);
            },
            expression: "value.refs"
          }
        }), _c('m-detail-table', {
          attrs: {
            "title": _vm.$t('about'),
            "item": _vm.value,
            "i18nPath": "objects.repairEstimateRequest",
            "config": _vm.detailTableConfig
          }
        }), _c('v-divider', {
          staticClass: "mt-6"
        }), _c('m-action-list', {
          attrs: {
            "actions": _vm.bottomActions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_vm.isDocumentLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : _vm.document ? _c('iframe', {
    staticClass: "pdf",
    staticStyle: {
      "height": "calc(100vh - 220px)",
      "width": "100%"
    },
    attrs: {
      "title": "pdf",
      "src": _vm.document.url
    }
  }) : _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('latest-entries-card-empty', {
    staticClass: "my-2"
  })], 1), _c('v-divider', {
    staticClass: "mt-2"
  }), _c('activity-card', {
    attrs: {
      "partner": _vm.partner,
      "source": _vm.source,
      "config": {
        comment: true,
        mail: false
      }
    }
  })], 1), _vm.isDeleteDialogActive && _vm.value ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading,
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }) : _vm._e(), _vm.selectedSharedContent ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.selectedSharedContent
    },
    on: {
      "close": function close($event) {
        _vm.selectedSharedContent = null;
      }
    }
  }) : _vm._e(), _vm.personSideCard ? _c('person-side-card', {
    attrs: {
      "value": _vm.personSideCard
    },
    on: {
      "close": function close($event) {
        _vm.personSideCard = null;
      }
    }
  }) : _vm._e(), _vm.companySideCard ? _c('company-side-card', {
    attrs: {
      "value": _vm.companySideCard
    },
    on: {
      "close": function close($event) {
        _vm.companySideCard = null;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }